import React from 'react';
import { ChartBarIcon, SparklesIcon } from '@heroicons/react/24/outline';
import parseQualityReportToHTML from '../../../shared/quality/parseQualityReportToHTML';

const Spinner = ({ className }) => (
  <svg className={`animate-spin ${className}`} fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
  </svg>
);

const QualityCheck = ({ qualityReport, onCheckQuality, isCheckingQuality }) => {
  const overallScore = qualityReport && qualityReport[0]?.quality_control_report?.['Overall Score'];
  const scorePercentage = overallScore ? parseInt(overallScore.percentage, 10) : 0;

  const getProgressBarColor = (score) => {
    if (score >= 80) return 'bg-primary-500';
    if (score >= 60) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  return (
    <div className="px-4 pt-2">
      {!qualityReport && (
        <div className="text-center py-8 mb-6">
          <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <ChartBarIcon className="w-8 h-8 text-gray-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">Content Quality Analysis</h3>
          <p className="text-gray-500 max-w-md mx-auto mb-6">
            Get detailed insights about your article&apos;s readability, SEO optimization, and overall quality score.
          </p>
        </div>
      )}

      {overallScore && (
        <div className="pb-6 mb-6 border-b border-gray-200">
          <div className="space-y-2">
            <span className="text-base font-semibold text-gray-900">Overall Score: {scorePercentage}%</span>
            <div className="relative w-full bg-neutral-200 rounded-full overflow-hidden" style={{ height: '8px' }}>
              <div
                className={`absolute inset-y-0 left-0 rounded-full transition-all duration-500 ${getProgressBarColor(scorePercentage)}`}
                style={{ width: `${scorePercentage}%` }}
              />
            </div>
            <p className="text-sm text-gray-600 mt-2">
              Based on word count, title length, headings structure, and keyword optimization
            </p>
          </div>
        </div>
      )}
      {qualityReport && Array.isArray(qualityReport) && qualityReport.length > 0
        ? parseQualityReportToHTML(qualityReport)
        : <p>No quality report available. Click the button below to generate a report.</p>}
      <button
        onClick={onCheckQuality}
        className={`w-full flex items-center justify-center gap-2 text-sm font-medium py-3 px-4 rounded-lg mt-6 transition-colors ${
          isCheckingQuality
            ? 'bg-primary-400 cursor-not-allowed'
            : 'bg-primary-500 text-white hover:bg-primary-600'
        }`}
        disabled={isCheckingQuality}
      >
        {isCheckingQuality ? (
          <Spinner className="w-4 h-4 text-white" />
        ) : (
          <SparklesIcon className="w-4 h-4" />
        )}
        <span className={isCheckingQuality ? 'animate-pulse bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent' : 'text-white'}>
          {isCheckingQuality ? 'Analyzing Content...' : 'Analyze Content Quality'}
        </span>
      </button>
    </div>
  );
};

export default QualityCheck;
